import { evaluateAdvancedCriteria, evaluateConditionGroup } from './advancedCriteriaEvaluation';

const missing = value => value === undefined || value === null || String(value).trim() === '';

// The visibility setting uses the same saved criteria as match scoring.
export function evaluateLenderVisibility(lender, enabled, getFieldValue, evaluateCriterion) {
  if (!enabled || !lender?.hideUntilQualified) return { visible: true, result: null };

  const inheritRequired = rule => ({
    ...rule,
    thenCriteria: (rule.thenCriteria || []).map(c => ({ ...c, required: c.required || rule.required })),
    elseCriteria: (rule.elseCriteria || []).map(c => ({ ...c, required: c.required || rule.required })),
    nestedRules: (rule.nestedRules || []).map(inheritRequired)
  });
  const criteria = { ...lender, conditionalRules: (lender.conditionalRules || []).map(inheritRequired) };
  const result = evaluateAdvancedCriteria(criteria, getFieldValue, evaluateCriterion);
  const groupMissing = group => (group?.conditions || []).some(c => missing(getFieldValue(c.fieldId))) ||
    (group?.groups || []).some(groupMissing);
  const ruleMissing = rule => rule.enabled && (groupMissing(rule.conditionGroup) ||
    (evaluateConditionGroup(rule.conditionGroup, getFieldValue) && (rule.nestedRules || []).some(ruleMissing)));
  const requiredResults = [...result.simpleMatched, ...result.simpleMissed, ...result.simpleIncomplete,
    ...result.conditionalMatched, ...result.conditionalMissed, ...result.conditionalIncomplete].filter(c => c.required);
  return {
    visible: requiredResults.length > 0 && !result.disqualified &&
      ![...result.simpleIncomplete, ...result.conditionalIncomplete].some(c => c.required) &&
      !criteria.conditionalRules.some(ruleMissing),
    result
  };
}
